<div class="logo-container">
    <img
        class="logo"
        [alt]="fullLogo.alt"
        [src]="fullLogo.src">
    @if (isLTI) {
        <div class="lti-version">
            <span [attr.aria-label]="'logo-version' | translate : { versionNumber: version }">
                {{ version }}
            </span>
        </div>
    }
</div>
